import React, { createRef, useEffect, useState } from 'react'
import { useParams, useLocation, Link } from 'react-router-dom'
import Projects from '../components/Projects.json'
import Spinner from '../components/Spinner'
import GalleriaRow from '../components/GalleriaRow'
import img from '../assets/Banners/Banner - 001_shorter.jpg'

export default function ViewProjects(props) {

    const { id } = useParams();
    const [project, setProject] = useState()
    const [precinct, setPrecinct] = useState('')
    const [precinct2, setPrecinct2] = useState('')
    const [number, setNumber] = useState('')
    const [title, setTitle] = useState('')
    const [funding, setFunding] = useState('')
    const [desc, setDesc] = useState('')
    const [filePath, setFilePath] = useState('')
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(true)
    const [statusUpdate, setStatusUpdate] = useState("")
    const [designer, setDesigner] = useState("")
    const [images, setImages] = useState([])
    const [imageButtons, setImageButtons] = useState([])
    const [imagesConst, setImagesConst] = useState(null)
    const [conPercent, setConPercent] = useState()
    const [preConPercent, setPreConPercent] = useState()
    const [phase, setPhase] = useState("")
    const [trafficUpdate, setTrafficUpdate] = useState()
    const [trafficImg, setTrafficImg] = useState([])
    const [contractor, setContractor] = useState("")
    const [constructionUpdate, setConstructionUpdate] = useState("")
    const [constructionImgs, setConstructionImgs] = useState([])

    const ref = createRef();
    const { pathname } = useLocation();
    const path = pathname.split("/")

    useEffect(() => {
        var data = null;

        for (let i = 0; i < Projects.length; i++) {
            if (id == Projects[i].id) {
                data = Projects[i]
            }
        }
        if (data == null) {
            setError(true)
        }

        var _images = []
        var _imageButtons = []

        if (data !== null) {
            if (data.photos != null) {
                for (let i = 0; i < data.photos.length; i++) {
                    if (i === 0) {
                        _images.push(<div className="carousel-item active" key={i}><img className='d-block w-100 img-fluid' src={data.photos[i]} alt="&nbsp;&nbsp;Unavailable" /></div>)
                        if (data.photos.length > 1) _imageButtons.push(<button type="button" data-bs-target="#projectCarousel" data-bs-slide-to={i} className="active" aria-current="true" aria-label={`Slide ${i + 1}`} key={i} />)
                    }
                    else {
                        _images.push(<div className="carousel-item" key={i}><img className='d-block w-100 img-fluid' src={data.photos[i]} alt="&nbsp;&nbsp;Unavailable" /></div>)
                        _imageButtons.push(<button type="button" data-bs-target="#projectCarousel" data-bs-slide-to={i} aria-label={`Slide ${i + 1}`} key={i} />)
                    }
                }
            }

            // Set construction photos directly
            setImagesConst(data.photos || [])
        }

        setImages(_images)
        setImageButtons(_imageButtons)
        setLoading(false)

        setProject(data)
        setPrecinct(data.precinct)
        setNumber(data.number)
        setTitle(data.title)
        setFunding(data.funding)
        setPhase(data.phase)
        setTrafficUpdate(data.trafficUpdate != undefined ? data.trafficUpdate : "")
        setTrafficImg(data.trafficImg)
        setDesc(data.desc)
        setFilePath(data.filePath)
        setStatusUpdate(data.statusUpdate != undefined ? data.statusUpdate : "")
        setDesigner(data.designer != "" ? data.designer : "To be determined")
        setContractor(data.contractor != "" ? data.contractor : "To be determined")
        setConstructionUpdate(data.constructionUpdate)
        setConstructionImgs(data.constructionPhotos)

        if (data.conPercent != null || data.conPercent != undefined) {
            setConPercent(parseInt(data.conPercent))
        } else {
            setConPercent(null)
        }

        if (data.preConPercent != null || data.preConPercent != undefined) {
            setPreConPercent(parseInt(data.preConPercent))
        } else {
            setPreConPercent(null)
        }

        if (String(data.precinct2).length <= 5) {
            var prec = "& " + data.precinct2
            setPrecinct2(prec)
        } else {
            setPrecinct2("")
        }

        setLoading(false)
    }, [id]);


    if (path[1].toLowerCase() === 'viewprojects') {
        if (isNaN(path[2])) return (window.location.href = "/NotFound")
        const projId = parseInt(path[2])
        if (projId < 1) return (window.location.href = "/NotFound")
    }

    if (loading) {
        return (<main className='flex-shrink-0 modular min-vh-100'><Spinner padding={5} /></main>)
    }

    if (error) {
        return (<main className='flex-shrink-0 modular min-vh-100'><div>Page Not Found</div></main>)
    }

    return (
        <div>
            <main className='flex-shrink-0 modular min-vh-100'>
                <div style={{ position: "relative", width: "100%" }}>
                    <img
                        src={img}
                        className="d-block w-100"
                        style={{ objectFit: "cover", height: "175px" }}
                        alt=''
                    />
                    <div style={{
                        position: "absolute",
                        top: "50%",
                        left: "0",
                        right: "0",
                        transform: "translateY(-50%)",
                        textAlign: "center",
                    }}>
                        <div className="container">
                            <h5 id="bannerText">Project {number} / Precinct {precinct} {precinct2}</h5>
                            <h1 style={{ fontWeight: '600', fontSize: 'clamp(0.8rem, 3vw, 2.5rem)' }} id="bannerText">
                                {title}
                            </h1>
                        </div>
                    </div>
                </div>
                <div ref={ref} className="container py-4 text-center">
                    <div className="row my-2 text-start g-3 align-items-start">

                        {/* LEFT COLUMN */}
                        <div className="col-lg-6 d-flex flex-column gap-3">

                            {/* construction card */}
                            {((contractor !== "" && contractor !== "To be determined") || (constructionUpdate && constructionUpdate !== "") || constructionImgs?.length > 0) && (
                                <div className='card shadow'>
                                    <div className='card-body'>
                                        {((contractor !== "" && contractor !== "To be determined") || (constructionUpdate && constructionUpdate !== "")) && (<>
                                            <h4>Construction Information</h4>
                                            {contractor !== "" && contractor !== "To be determined" && <p><b>Contractor:</b> {contractor}</p>}
                                            {constructionUpdate && constructionUpdate !== "" && <p><b>Construction Update:</b> {constructionUpdate}</p>}
                                        </>)}
                                        {constructionImgs?.length > 0 && (<>
                                            <h4>Construction Photos</h4>
                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '8px' }}>
                                                {constructionImgs.map((link, index) => (
                                                    <a key={index} href={link} target="_blank" rel="noopener noreferrer">
                                                        <img src={link} alt=''
                                                            style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '4px', display: 'block', cursor: 'pointer' }} />
                                                    </a>
                                                ))}
                                            </div>
                                        </>)}
                                    </div>
                                </div>
                            )}

                            {/* traffic update */}
                            {trafficUpdate !== "" && (
                                <div className='card shadow'>
                                    <div className='card-body'>
                                        <h4>Traffic Updates</h4>
                                        <p>{trafficUpdate}</p>
                                        <div >
                                            {trafficImg.map((link, index) => (
                                                <a key={index} href={link} target="_blank" rel="noopener noreferrer">
                                                    <img src={link} alt=''
                                                        style={{ width: '100%', objectFit: 'cover', borderRadius: '4px', display: 'block', cursor: 'pointer' }} />
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* project map image */}
                            {id != 7 && String(filePath).length > 0 && (
                                <div className='card shadow'>
                                    <div className='card-body'>
                                        <a href={filePath} target='_blank'>
                                            <img style={{ objectFit: "cover", width: "100%" }} alt="project" src={filePath} />
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* RIGHT COLUMN */}
                        <div className="col-lg-6 d-flex flex-column gap-3">

                            {/* progress bars */}
                            {(preConPercent != null || conPercent != null) && (
                                <div className="card shadow">
                                    <div className='card-body'>
                                        <h4 className='text-start'>Project Progress</h4>
                                        {preConPercent != null && (
                                            <div className="px-5 col-12">
                                                <svg width="100%" height="80" viewBox="-60 -20 920 120" preserveAspectRatio="xMidYMid meet">
                                                    <rect x="0" y="20" width={preConPercent * 8} height="60" fill="#2ca03d" />
                                                    <rect x={preConPercent * 8} y="20" width={(100 - preConPercent) * 8} height="60" fill="#4bce5e" />
                                                    <rect x={preConPercent * 8 - 50} y="-20" width="100" height="55" rx="8" fill="white" stroke="#e5e7eb" strokeWidth="2" />
                                                    <text x={preConPercent * 8} y="5" fill="#1f2937" fontSize="24" fontWeight="bold" textAnchor="middle">{preConPercent}%</text>
                                                    <text x={preConPercent * 8} y="25" fill="#6b7280" fontSize="20" textAnchor="middle">Complete</text>
                                                </svg>
                                                <h6 className='text-center'>Pre-construction Phase</h6>
                                            </div>
                                        )}
                                        {conPercent != null && (
                                            <div className="px-5 col-12">
                                                <svg width="100%" height="80" viewBox="-60 -20 920 120" preserveAspectRatio="xMidYMid meet">
                                                    <rect x="0" y="20" width={conPercent * 8} height="60" fill="#ff6600" />
                                                    <rect x={conPercent * 8} y="20" width={(100 - conPercent) * 8} height="60" fill="#ffa366" />
                                                    <rect x={conPercent * 8 - 50} y="-20" width="100" height="55" rx="8" fill="white" stroke="#e5e7eb" strokeWidth="2" />
                                                    <text x={conPercent * 8} y="5" fill="#1f2937" fontSize="24" fontWeight="bold" textAnchor="middle">{conPercent}%</text>
                                                    <text x={conPercent * 8} y="25" fill="#6b7280" fontSize="20" textAnchor="middle">Complete</text>
                                                </svg>
                                                <h6 className='text-center'>Construction Phase</h6>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* description / status / phase */}
                            <div className='card shadow'>
                                <div className='card-body'>
                                    <h4>Description</h4>
                                    <p style={{ whiteSpace: 'pre-wrap' }}>{desc}</p>
                                    {statusUpdate !== "" && (
                                        <div>
                                            <h4>Status Update</h4>
                                            <div dangerouslySetInnerHTML={{ __html: statusUpdate }}></div>
                                        </div>
                                    )}
                                    {phase !== "" && (
                                        <div className='pt-2'>
                                            <h4>Phase</h4>
                                            <p>{phase}</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div>
                        {id == 7 ?
                            <div className='card shadow'>
                                <div className='card-body'>
                                    {(String(filePath).length === 0) ? " " :
                                        <a href={filePath} target='_blank'>
                                            <img style={{ objectFit: "cover", width: "100%" }} alt="project" src={filePath} />
                                        </a>}
                                </div>
                            </div> :
                            <></>}
                    </div>

                    {imagesConst.length !== 0 ?
                        <div className='card shadow'><GalleriaRow item={imagesConst} id={id} /></div>
                        :
                        <div></div>
                    }
                    <div className='pt-4'>
                        <Link to="/projects" style={{ textDecoration: "none" }}>
                            <div className='btn btn-outline-secondary btn-sm'><i className='fa-back'></i>Back to Projects Map</div>
                        </Link>
                    </div>
                </div>

            </main >
        </div >
    )
}